import React from "react";
import { ScrollingCarousel } from "@trendyol-js/react-carousel";
import styled from "styled-components";

function CarouselMedals({ medals }) {
  if (!medals || medals.length === 0) return null;

  return (
    <CarouselWrapper>
      <ScrollingCarousel>
        {medals.map((medalNumber, index) => (
          <Medal key={index}>
            <Img
              src={`${process.env.PUBLIC_URL}/medals/${medalNumber}.png`}
              alt={`Madalya ${medalNumber}`}
              loading="lazy" // ✅ Lazy load ile performans artırıldı
            />
          </Medal>
        ))}
      </ScrollingCarousel>
    </CarouselWrapper>
  );
}

const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 120px;
`;

const Medal = styled.div`
  display: inline-block;
  margin-right: 10px;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid var(--main-color);
`;

const Img = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
`;

export default CarouselMedals;
